<template>
  <div
    data-qa="appointment_calendar_skeleton"
    class="appointment-calendar-skeleton"
  >
    <v-skeleton-loader
      data-qa="appointment_calendar_skeleton_collapsed"
      class="appointment-calendar-skeleton_collapsed"
      type="text"
    />
    <div
      v-if="!isCollapsed"
      data-qa="appointment_calendar_skeleton_expanded"
      class="appointment-calendar-skeleton_expanded"
    >
      <template v-if="isMobile">
        <v-skeleton-loader
          class="appointment-calendar-skeleton__day-selector"
          type="button,text,button"
        />
        <v-skeleton-loader
          class="appointment-calendar-skeleton__slots"
          type="button@8"
        />
      </template>
      <v-skeleton-loader
        v-else
        class="appointment-calendar-skeleton__desktop-calendar"
        type="text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentCalendarSkeleton',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isMobile: window.MOBILE_VERSION,
  }),
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.appointment-calendar-skeleton {
  &_collapsed::v-deep .v-skeleton-loader__text {
    height: 42px;
    border-radius: $border-radius-md;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  &__alert::v-deep .v-skeleton-loader__text {
    height: 36px;
    margin-bottom: 16px;
  }

  &__day-selector::v-deep {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    & .v-skeleton-loader {
      &__button {
        height: 32px;
        width: 32px;
        border-radius: $border-radius-md;
      }

      &__text {
        height: 24px;
        width: 120px;
        flex: 0 0 auto;
        margin: 0;
        border-radius: $border-radius-md;
      }
    }
  }

  &__slots::v-deep {
    display: flex;
    flex-wrap: wrap;

    & .v-skeleton-loader__button {
      width: calc(25% - 8px);
      margin: 0 10px 10px 0;
      height: 40px;

      &:nth-of-type(4n) {
        margin-right: 0;
      }
    }
  }

  &__desktop-calendar::v-deep .v-skeleton-loader__text {
    height: 236px;
    margin: 0;
  }
}
</style>
